import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-200/10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950">四虎影院</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              海量高清影视资源免费在线观看。涵盖电影、电视剧、综艺、动漫等多种类型，每日更新，追剧观影首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  免责声明
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系方式</h4>
            <div className="space-y-3 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                contact@realsmodel.cn
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-500"></i>
                在线客服：7×24小时
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500"></i>
                微信公众号：四虎影院
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 四虎影院 realsmodel.cn 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors text-lg" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors text-lg" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors text-lg" aria-label="QQ">
              <i className="ri-qq-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}